import qs from 'qs'

export const getAcademyAbout = (axios) => {
  const query = qs.stringify(
    {
      populate: [
        'cover_image',
        'serp',
        'yellow_block_points',
        'yellow_block_points.bod',
        'promo_seal'
      ],
    },
    {
      encodeValuesOnly: true,
    }
  )

  return axios.get(`/api/akademie-o-nas?${query.trim()}`)
}
